export const projectImageMessagesShared = {
  readonlyProjectMessage: [
    'このプロジェクトは承認済みで、データを編集することができません。',
    '「結果図面・CSVファイルのダウンロード」から色付き図面・結果CSVのダウンロードを行うことができます。'
  ]
} as const;
